// @ts-nocheck

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable for-direction */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-useless-escape */
/* eslint-disable no-else-return */
/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { useState, useEffect } from 'react'
import Cookies from 'js-cookie'

import TagManager from 'react-gtm-module'
import moment from 'moment'
import { Roles } from 'Constants/enums'
import { TFunction } from 'react-i18next'
import { CURRENCY } from './currency'
import { gaReferrerBlacklist } from './constants'

export const getRandomInt = (max: number) =>
  Math.floor(Math.random() * Math.floor(max))

export function randomInteger(min: number, max: number) {
  const rand = min + Math.random() * (max + 1 - min)
  return Math.floor(rand)
}

export const roundTo10 = (num: number) => Math.floor(num / 10) * 10

export const roundTo10or50 = (num: number) =>
  num < 500 ? Math.floor(num / 10) * 10 : Math.floor(num / 50) * 50

export const kFormatter = (num: number) => {
  if (num > 999 && num < 1000000) {
    return `${Math.sign(num) *
      parseFloat((Math.abs(num) / 1000).toFixed(3).slice(0, -1))}k`
  }
  if (num > 1000000) {
    return `${Math.sign(num) *
      parseFloat((Math.abs(num) / 1000000).toFixed(3).slice(0, -1))}m`
  }
  return Math.sign(num) * Math.abs(num)
}

export const checkCuratorRank = (score: number): number => {
  if (score < 1500) {
    return 1
  }
  if (score >= 1500 && score < 5000) {
    return 2
  }
  if (score >= 5000 && score < 10000) {
    return 3
  }
  if (score >= 10000 && score < 25000) {
    return 4
  }
  if (score >= 25000 && score < 50000) {
    return 5
  }
  if (score >= 50000 && score < 75000) {
    return 6
  }
  if (score >= 75000 && score < 100000) {
    return 7
  }
  if (score >= 100000 && score < 150000) {
    return 8
  }
  if (score >= 150000 && score < 200000) {
    return 9
  }
  if (score >= 200000 && score < 250000) {
    return 10
  }
  if (score >= 250000 && score < 300000) {
    return 11
  } else if (score >= 300000 && score < 400000) {
    return 12
  } else if (score >= 400000 && score < 500000) {
    return 13
  } else if (score >= 500000 && score < 650000) {
    return 14
  } else if (score >= 650000) {
    return 15
  } else {
    return 0
  }
}

export function debounce(f: Function, ms: number) {
  let isCooldown = false

  // eslint-disable-next-line func-names
  return () => {
    if (isCooldown) return

    // @ts-ignore
    f.apply(this, arguments)

    isCooldown = true

    setTimeout(() => (isCooldown = false), ms)
  }
}

export function dateDiffInDays(a: Date, b: Date) {
  const utc1 = Date.UTC(
    a.getFullYear(),
    a.getMonth(),
    a.getDate(),
    a.getHours(),
    a.getMinutes(),
    a.getSeconds(),
    a.getMilliseconds()
  )
  const utc2 = Date.UTC(
    b.getFullYear(),
    b.getMonth(),
    b.getDate(),
    b.getHours(),
    b.getMinutes(),
    b.getSeconds(),
    b.getMilliseconds()
  )

  return Math.floor(utc2 - utc1)
}

export const currencySymbolConverter = (currency: string) => {
  if (CURRENCY.hasOwnProperty(currency)) {
    return CURRENCY[currency as keyof typeof CURRENCY]
  }

  return currency
}

export const getCookieByName = (str: string) => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${str.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

export const checkReferrerUrl = (url: string) => {
  let res = true

  for (let i = 0; i < gaReferrerBlacklist.length; i += 1) {
    if (url.includes(gaReferrerBlacklist[i])) {
      res = false
    }
  }

  return res
}

export const getUtmParameters = (str: string | undefined) => {
  //  eslint-disable-next-line @typescript-eslint/no-explicit-any
  const obj: any = {}
  const fbp = getCookieByName('_fbp')
  const fbc = getCookieByName('_fbc')
  const userAgent = window.navigator.userAgent
  const isReferrerUrlValid = checkReferrerUrl(document.referrer)

  if (document.referrer && isReferrerUrlValid) {
    obj.referrer_url = document.referrer
  }

  if (fbp) obj.fbp = fbp
  if (fbc) obj.fbc = fbc
  if (userAgent) obj.client_user_agent = userAgent

  if (typeof str === 'string') {
    const splitedStr = str.slice(1).split('&')

    for (let i = 0; i < splitedStr.length; i += 1) {
      const newSplitedStr = splitedStr[i].split('=')
      obj[newSplitedStr[0]] = decodeURIComponent(newSplitedStr[1])
    }
  }

  return obj
}

export const numberWithCommas = (num: number) => {
  const parts = num.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export const stringToNumber = (string: string) => {
  const withoutString = string.replace(',', '')
  return Number(withoutString)
}

export const numberFormatSpaces = (number: number | undefined) =>
  number ? number.toLocaleString('fr', { maximumFractionDigits: 2 }) : 0

export const numberFormatCommas = (number: number | undefined) =>
  number ? number.toLocaleString('en-US', { maximumFractionDigits: 2 }) : 0
export const toStringAndReplace = (value: number) =>
  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const setGTMevent = dataLayer => {
  TagManager.dataLayer({
    dataLayer: { ...dataLayer },
  })
}

export const hidePartOfEmailWithStars = string => {
  const firstLetterOfEmail = string.slice(0, 1)
  const hiddenPartOfEmail = string
    .substring(0, string.indexOf('@') - 1)
    .replace(/./gi, '*')
  const secondPartOfEmail = string.substring(string.indexOf('@') + 1)

  const result = `${firstLetterOfEmail}${hiddenPartOfEmail}@${secondPartOfEmail}`
  return result
}

export const renderRole = (userRole: Roles, t: TFunction) => {
  if (userRole === Roles.curator) {
    return t('sidebar.curator')
  }

  if (userRole === Roles.artist) {
    return t('sidebar.artist')
  }

  if (userRole === Roles.influencer) {
    return t('sidebar.influencer')
  }
  return ''
}

export const removeCookiesHandler = () => {
  Cookies.remove('_ga')
  Cookies.remove('_ga_SL7L905HG4')
  Cookies.remove('_ga_KW228JVF2P')
  Cookies.remove('sondcsrd')
}

export const useContainerSize = myRef => {
  const getDimensions = () => ({
    width: myRef.current.offsetWidth,
    height: myRef.current.offsetHeight,
  })

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions())
    }

    if (myRef.current) {
      setDimensions(getDimensions())
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [myRef])

  return dimensions
}

export const calculateDaysLeft = (endDate: Date): number =>
  moment(endDate).diff(moment(), 'days') + 1
